import { render, staticRenderFns } from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=template&id=7851c920&scoped=true"
import script from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851c920",
  null
  
)

export default component.exports